import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../components/ui/button/Buttons";
import { decryptAESID, encryptAESID } from "../../../utils/Encryption";
import { useNavigate, useParams } from "react-router-dom";
import { useAdminComitteeApproveOrRejectForIndividualCourseMutation } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { EditCommitteeApproval } from "../data/EditCommitteeApproval.Data";
import FormCreator from "../../../components/Forms/FormCreator";
import SwalAlert from "../../../services/swalService/SwalService";

const EditCommitteApproval = (props) => {
    const { id } = useParams();
    const editID = id ? decryptAESID(id, false) : 0
    const navigate = useNavigate();
    const accountManagementFormDataRef = useRef();
    const selectedId = props.selectedId ? decryptAESID(props.selectedId) : 0;
    const [formData, setFormData] = useState(EditCommitteeApproval);
    const [committeApproveOrReject, { isSuccess: isSuccessCommitteApproveOrReject, isLoading: isFetchingAppCommitteApproveOrReject, data: CommitteApproveOrRejectResponse },] = useAdminComitteeApproveOrRejectForIndividualCourseMutation();
    const { success, error } = SwalAlert();
    useEffect(() => {
        if (!isFetchingAppCommitteApproveOrReject && isSuccessCommitteApproveOrReject && CommitteApproveOrRejectResponse) {
            if (CommitteApproveOrRejectResponse.errorMessage == "Approved") {
                success("Application Approved Successfully");
                backToList();
            }
            else {
                error("Your Application has been rejected");
                backToList();
            }
        }
    }, [isFetchingAppCommitteApproveOrReject, isSuccessCommitteApproveOrReject, CommitteApproveOrRejectResponse]);

    const backToList = () => {
        props.isModelClose();
        navigate(`/editCourseProvider/${encryptAESID(editID)}`);
        props.getCommiteeApprovalList(editID)
    }

    const handleCommitteApprove = () => {
        let commiteeFormData = accountManagementFormDataRef.current.getFormData();
        let request = {
            GMPCourseProviderId: editID,
            CommitteeAdminId: selectedId,
            Comment: commiteeFormData?.comments || null,
            IsReject: false,
        }
        committeApproveOrReject(request);
    }

    const handleCommitteReject = () => {
        let commiteeFormData = accountManagementFormDataRef.current.getFormData();
        let request = {
            GMPCourseProviderId: editID,
            CommitteeAdminId: selectedId,
            Comment: commiteeFormData?.comments || null,
            IsReject: true,
        }
        committeApproveOrReject(request);
    }

    return (
        <div>
            <div className='row'>
                <FormCreator ref={accountManagementFormDataRef} {...formData} />
                <div className='col-lg-12 d-flex justify-content-between mt-2'>
                    <Buttons
                        buttonText={"Approve"}
                        buttonTypeClassName="btn success-btn"
                        onClick={handleCommitteApprove}
                    />
                    <Buttons
                        buttonText={"Reject"}
                        buttonTypeClassName="red-btn ml-auto"
                        onClick={handleCommitteReject}
                    />
                </div>

            </div>
        </div>
    );
};

export default EditCommitteApproval;
